var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEfficiency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9425 8.74512L18.7502 9.44183L13.484 15.5468H20.4361L14.0114 23.3524L13.1879 22.6745L18.1766 16.6135H11.1553L17.9425 8.74512Z",
    fill: "url(#paint0_linear_12673_175418)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1985 14.6078C25.8606 12.1335 24.6348 9.86643 22.7494 8.22893C20.864 6.59142 18.4475 5.69519 15.9503 5.70719C13.4531 5.7192 11.0454 6.63863 9.17582 8.29419C7.30623 9.94975 6.10226 12.2285 5.78821 14.7059C5.47416 17.1834 6.07145 19.6905 7.46882 21.7602C8.86618 23.8298 10.9683 25.321 13.3835 25.9557L13.1124 26.9873C10.4469 26.2868 8.12694 24.6412 6.58478 22.357C5.04261 20.0729 4.38342 17.3059 4.73001 14.5718C5.0766 11.8376 6.40535 9.32273 8.46868 7.49562C10.532 5.6685 13.1892 4.65379 15.9452 4.64054C18.7012 4.62729 21.368 5.6164 23.4488 7.42359C25.5296 9.23079 26.8825 11.7328 27.2554 14.4635C27.6282 17.1942 26.9957 19.9673 25.4755 22.2662C23.9554 24.5651 21.6514 26.2329 18.9927 26.9591L18.7117 25.9301C21.1207 25.2721 23.2084 23.7609 24.5858 21.6779C25.9632 19.5948 26.5364 17.0821 26.1985 14.6078Z",
    fill: "url(#paint1_linear_12673_175418)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5088 19.9396C26.4644 17.6324 26.5488 15.0565 25.746 12.6918C24.9433 10.3271 23.3083 8.33485 21.1457 7.08623C18.983 5.83761 16.4401 5.41778 13.9909 5.90497C11.5416 6.39216 9.35297 7.75314 7.83274 9.73434C6.31252 11.7155 5.56437 14.1818 5.7277 16.6737C5.89103 19.1656 6.95469 21.5132 8.7205 23.279L7.96626 24.0332C6.01745 22.0844 4.84357 19.4936 4.66332 16.7435C4.48306 13.9934 5.30874 11.2715 6.9865 9.08499C8.66427 6.89849 11.0797 5.39648 13.7828 4.8588C16.4858 4.32113 19.2922 4.78446 21.679 6.16247C24.0658 7.54048 25.8702 9.73919 26.7561 12.349C27.642 14.9587 27.5489 17.8016 26.4943 20.3478C25.4396 22.894 23.4952 24.97 21.0234 26.189C18.5516 27.4079 15.7209 27.6867 13.0588 26.9734L13.3349 25.9431C15.747 26.5894 18.3119 26.3368 20.5516 25.2323C22.7913 24.1278 24.5531 22.2467 25.5088 19.9396Z",
    fill: "url(#paint2_linear_12673_175418)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12673_175418",
    x1: 15.7957,
    y1: 8.74512,
    x2: 15.7957,
    y2: 23.3524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12673_175418",
    x1: 26.9585,
    y1: 13.0075,
    x2: 5.04116,
    y2: 18.9933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12673_175418",
    x1: 26.9719,
    y1: 18.9407,
    x2: 5.02608,
    y2: 13.0603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7100"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfficiency);
export default __webpack_public_path__ + "static/media/efficiency.00ffe4c19545d1a9ddc6b7953f94842d.svg";
export { ForwardRef as ReactComponent };